import React from 'react';

function Notfound() {
	return (
		<div className="mt-5" >
			<h1 className="text-center mt-5">404 Page Not found</h1>
		</div>
	);
}

export default Notfound;